import React from 'react';
import {Calendar, momentLocalizer} from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {AuthContext} from "../context/Auth";
import Axios from "axios";
import {AgendaEvent} from "../models/commercial/AgendaEvent";
import Modal from 'react-modal'

const localizer = momentLocalizer(moment);
Modal.setAppElement('#root'); // Asegura que el modal está asociado con el elemento raíz de tu aplicación

export class AgendaCalendar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            agendaEvents: [],
            selectedEvent: null,
        }

    }

    handleSelectEvent = event => {
        this.setState({ selectedEvent: event });
    };

    closeModal = () => {
        this.setState({ selectedEvent: null });
    };

    componentDidMount() {

        Axios.get('/agendaevents').then(results => {
            let agendaEventsMapped =  results.data.map((agendaEventResult) => {
                    let agendaEvent = new AgendaEvent();
                    agendaEvent.bindAgendaEvent(agendaEventResult);
                    return agendaEvent;
            });
            agendaEventsMapped = agendaEventsMapped.filter( agendaEventResult => agendaEventResult.type !== 'systemauto') ;
            this.setState({agendaEvents: agendaEventsMapped});
        }, error => {
            console.log('error', error);
        });
    }

    render() {
        return (
            <div style={{height: '500px'}}>
                <Calendar
                    localizer={localizer}
                    events={this.state.agendaEvents}
                    startAccessor="start"
                    endAccessor="end"
                    defaultView="month"
                    onSelectEvent={this.handleSelectEvent}
                />

                {/* Modal para mostrar detalles del evento seleccionado */}
                <Modal
                    isOpen={!!this.state.selectedEvent}
                    onRequestClose={this.closeModal}
                    contentLabel="Detalles del Evento"
                >
                    {this.state.selectedEvent && (
                        <div>
                            <h3>{this.state.selectedEvent.title}</h3>
                            <p>{this.state.selectedEvent.details}</p>
                            <button onClick={this.closeModal}>Cerrar</button>
                        </div>
                    )}
                </Modal>

            </div>
        );
    }
}

AgendaCalendar.contextType = AuthContext;
export default AgendaCalendar;
